"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Ruler: ['ruler', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.562,6.638a1.5,1.5,0,0,0,0-2.121L19.476.43a1.541,1.541,0,0,0-2.121,0l-2.781,2.78a.251.251,0,0,0,0,.352l2.284,2.33a.5.5,0,1,1-.714.7L13.869,4.273a.257.257,0,0,0-.177-.075.248.248,0,0,0-.178.074L11.32,6.465a.251.251,0,0,0,0,.353L14.2,9.741a.5.5,0,0,1-.713.7L10.614,7.527a.248.248,0,0,0-.177-.074.251.251,0,0,0-.178.073L7.693,10.093a.25.25,0,0,0,0,.353L9.969,12.74a.5.5,0,0,1-.71.7l-2.273-2.29a.252.252,0,0,0-.177-.074.249.249,0,0,0-.177.073L4.247,13.538a.249.249,0,0,0,0,.352l2.71,2.752a.5.5,0,0,1-.713.7L3.541,14.6a.248.248,0,0,0-.177-.075.251.251,0,0,0-.178.073L.438,17.347a1.5,1.5,0,0,0,0,2.121l4.086,4.087a1.5,1.5,0,0,0,2.121,0Z']],
  GridRulerAlternate: ['grid-ruler-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.25,17A1.752,1.752,0,0,1,17,15.25h6.75A.25.25,0,0,0,24,15V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3H15a.25.25,0,0,0,.25-.25ZM22,7.25a.25.25,0,0,1-.25.25h-14a.25.25,0,0,0-.25.25v14a.25.25,0,0,1-.25.25h-1A.25.25,0,0,1,6,21.75v-2a.25.25,0,0,0-.25-.25H3A.75.75,0,0,1,3,18H5.75A.25.25,0,0,0,6,17.75v-2a.25.25,0,0,0-.25-.25H4A.75.75,0,0,1,4,14H5.75A.25.25,0,0,0,6,13.75v-2a.25.25,0,0,0-.25-.25H3A.75.75,0,0,1,3,10H5.75A.25.25,0,0,0,6,9.75v-2a.25.25,0,0,0-.25-.25H2.25A.25.25,0,0,1,2,7.25v-1A.25.25,0,0,1,2.25,6h3.5A.25.25,0,0,0,6,5.75V2.25A.25.25,0,0,1,6.25,2h1a.25.25,0,0,1,.25.25v3.5A.25.25,0,0,0,7.75,6h2A.25.25,0,0,0,10,5.75V3a.75.75,0,0,1,1.5,0V5.75a.25.25,0,0,0,.25.25h2A.25.25,0,0,0,14,5.75V4a.75.75,0,0,1,1.5,0V5.75a.25.25,0,0,0,.25.25h2A.25.25,0,0,0,18,5.75V3a.75.75,0,0,1,1.5,0V5.75a.25.25,0,0,0,.25.25h2a.25.25,0,0,1,.25.25Z', 'M17,16.75a.253.253,0,0,0-.25.25v6.7a.251.251,0,0,0,.3.246A3.774,3.774,0,0,0,18.914,23L23,18.914a3.778,3.778,0,0,0,.945-1.867.251.251,0,0,0-.246-.3Z']],
  GridDotAlternate: ['grid-dot-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,0H2.5A2.5,2.5,0,0,0,0,2.5v19A2.5,2.5,0,0,0,2.5,24h19A2.5,2.5,0,0,0,24,21.5V2.5A2.5,2.5,0,0,0,21.5,0ZM4.5,18.25A1.5,1.5,0,1,1,3,19.75,1.5,1.5,0,0,1,4.5,18.25Zm-1.5-6a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,3,12.25ZM5.5,16A1.5,1.5,0,1,1,7,17.5,1.5,1.5,0,0,1,5.5,16ZM8,12.25a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,8,12.25Zm1.5,6A1.5,1.5,0,1,1,8,19.75,1.5,1.5,0,0,1,9.5,18.25Zm1-2.25A1.5,1.5,0,1,1,12,17.5,1.5,1.5,0,0,1,10.5,16ZM13,12.25a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,13,12.25Zm1.5,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,14.5,18.25Zm1-2.25A1.5,1.5,0,1,1,17,17.5,1.5,1.5,0,0,1,15.5,16Zm4,2.25a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,19.5,18.25Zm0-4.5a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,19.5,13.75Z']],
  GridArtboard: ['grid-artboard', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,4.5a1,1,0,0,0,1-1V1A1,1,0,0,0,6,1V3.5A1,1,0,0,0,7,4.5Z', 'M4.5,7a1,1,0,0,0-1-1H1A1,1,0,0,0,1,8H3.5A1,1,0,0,0,4.5,7Z', 'M3.5,16H1a1,1,0,0,0,0,2H3.5a1,1,0,0,0,0-2Z', 'M17,0a1,1,0,0,0-1,1V3.5a1,1,0,0,0,2,0V1A1,1,0,0,0,17,0Z', 'M7,19.5a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V20.5A1,1,0,0,0,7,19.5Z', 'M17,19.5a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V20.5A1,1,0,0,0,17,19.5Z', 'M20.5,8H23a1,1,0,0,0,0-2H20.5a1,1,0,0,0,0,2Z', 'M23,16H20.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M18,7a1,1,0,0,0-1-1H7A1,1,0,0,0,6,7V17a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1Zm-2,8.5a.5.5,0,0,1-.5.5h-7a.5.5,0,0,1-.5-.5v-7A.5.5,0,0,1,8.5,8h7a.5.5,0,0,1,.5.5Z']],
  GridDot: ['grid-dot', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,0H3A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V3A3,3,0,0,0,21,0Zm1,21a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2H21a1,1,0,0,1,1,1Z', 'M3.750 18.750 A1.500 1.500 0 1 0 6.750 18.750 A1.500 1.500 0 1 0 3.750 18.750 Z', 'M8.250 18.750 A1.500 1.500 0 1 0 11.250 18.750 A1.500 1.500 0 1 0 8.250 18.750 Z', 'M12.750 18.750 A1.500 1.500 0 1 0 15.750 18.750 A1.500 1.500 0 1 0 12.750 18.750 Z', 'M17.250 18.750 A1.500 1.500 0 1 0 20.250 18.750 A1.500 1.500 0 1 0 17.250 18.750 Z', 'M3.750 12.250 A1.500 1.500 0 1 0 6.750 12.250 A1.500 1.500 0 1 0 3.750 12.250 Z', 'M8.250 12.250 A1.500 1.500 0 1 0 11.250 12.250 A1.500 1.500 0 1 0 8.250 12.250 Z', 'M12.750 12.250 A1.500 1.500 0 1 0 15.750 12.250 A1.500 1.500 0 1 0 12.750 12.250 Z', 'M17.250 12.250 A1.500 1.500 0 1 0 20.250 12.250 A1.500 1.500 0 1 0 17.250 12.250 Z', 'M6.000 15.500 A1.500 1.500 0 1 0 9.000 15.500 A1.500 1.500 0 1 0 6.000 15.500 Z', 'M10.500 15.500 A1.500 1.500 0 1 0 13.500 15.500 A1.500 1.500 0 1 0 10.500 15.500 Z', 'M15.000 15.500 A1.500 1.500 0 1 0 18.000 15.500 A1.500 1.500 0 1 0 15.000 15.500 Z']],
  GridMonitor: ['grid-monitor', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v16A1.5,1.5,0,0,0,1.5,19h21A1.5,1.5,0,0,0,24,17.5V1.5A1.5,1.5,0,0,0,22.5,0ZM22,14.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5Z', 'M14.35,20.681a.5.5,0,0,0-.385-.181h-3.93a.5.5,0,0,0-.385.181l-2.1,2.532A.5.5,0,0,0,7.96,24h8.079a.5.5,0,0,0,.41-.787Z', 'M16.5,6.25a.75.75,0,0,0,0-1.5H16a.25.25,0,0,1-.25-.25V4a.75.75,0,0,0-1.5,0v.5a.25.25,0,0,1-.25.25H13a.25.25,0,0,1-.25-.25V4a.75.75,0,0,0-1.5,0v.5a.25.25,0,0,1-.25.25H10a.25.25,0,0,1-.25-.25V4a.75.75,0,0,0-1.5,0v.5A.25.25,0,0,1,8,4.75H7.5a.75.75,0,0,0,0,1.5H8a.25.25,0,0,1,.25.25v1A.25.25,0,0,1,8,7.75H7.5a.75.75,0,0,0,0,1.5H8a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H7.5a.75.75,0,0,0,0,1.5H8a.25.25,0,0,1,.25.25V13a.75.75,0,0,0,1.5,0v-.5a.25.25,0,0,1,.25-.25h1a.25.25,0,0,1,.25.25V13a.75.75,0,0,0,1.5,0v-.5a.25.25,0,0,1,.25-.25h1a.25.25,0,0,1,.25.25V13a.75.75,0,0,0,1.5,0v-.5a.25.25,0,0,1,.25-.25h.5a.75.75,0,0,0,0-1.5H16a.25.25,0,0,1-.25-.25v-1A.25.25,0,0,1,16,9.25h.5a.75.75,0,0,0,0-1.5H16a.25.25,0,0,1-.25-.25v-1A.25.25,0,0,1,16,6.25ZM9.75,6.5A.25.25,0,0,1,10,6.25h1a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H10a.25.25,0,0,1-.25-.25ZM10,10.75a.25.25,0,0,1-.25-.25v-1A.25.25,0,0,1,10,9.25h1a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25Zm4.25-.25a.25.25,0,0,1-.25.25H13a.25.25,0,0,1-.25-.25v-1A.25.25,0,0,1,13,9.25h1a.25.25,0,0,1,.25.25Zm0-3a.25.25,0,0,1-.25.25H13a.25.25,0,0,1-.25-.25v-1A.25.25,0,0,1,13,6.25h1a.25.25,0,0,1,.25.25Z']],
  GridPerspective: ['grid-perspective', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.772,9.6a.251.251,0,0,0-.288-.247l-3.226.5a.249.249,0,0,0-.212.247v3.8a.249.249,0,0,0,.212.247l3.226.5a.251.251,0,0,0,.288-.247Z', 'M11.5,8.874a.251.251,0,0,0-.288-.247l-3.228.5a.249.249,0,0,0-.212.247v5.258a.249.249,0,0,0,.212.247l3.228.5a.251.251,0,0,0,.288-.247Z', 'M16.228,9.371a.249.249,0,0,0-.212-.247l-3.228-.5a.251.251,0,0,0-.288.247v6.252a.251.251,0,0,0,.288.247l3.228-.5a.249.249,0,0,0,.212-.247Z', 'M2.046,10.329a.251.251,0,0,0-.288-.248l-1.546.238A.251.251,0,0,0,0,10.567v2.866a.251.251,0,0,0,.212.248l1.546.238a.251.251,0,0,0,.288-.248Z', 'M20.954,10.1a.249.249,0,0,0-.212-.247l-3.226-.5a.251.251,0,0,0-.288.247v4.8a.251.251,0,0,0,.288.247l3.226-.5a.249.249,0,0,0,.212-.247Z', 'M24,10.567a.251.251,0,0,0-.212-.248l-1.546-.238a.251.251,0,0,0-.288.248v3.342a.251.251,0,0,0,.288.248l1.546-.238A.251.251,0,0,0,24,13.433Z', 'M6.56,8.331a.25.25,0,0,0,.212-.247V5.19a.25.25,0,0,0-.105-.2.246.246,0,0,0-.226-.032L3.214,6.071a.249.249,0,0,0-.168.236V8.58a.249.249,0,0,0,.288.247Z', 'M.288,14.7A.249.249,0,0,0,0,14.951v1.688a.251.251,0,0,0,.168.236l1.546.535a.249.249,0,0,0,.332-.236V15.189a.25.25,0,0,0-.212-.247Z', 'M23.712,9.3A.249.249,0,0,0,24,9.049V7.361a.251.251,0,0,0-.168-.236L22.286,6.59a.249.249,0,0,0-.332.236V8.811a.25.25,0,0,0,.212.247Z', 'M17.44,15.669a.25.25,0,0,0-.212.247V18.81a.25.25,0,0,0,.1.2.246.246,0,0,0,.226.032l3.227-1.117a.249.249,0,0,0,.168-.236V15.42a.249.249,0,0,0-.288-.247Z', 'M11.5,16.643a.25.25,0,0,0-.212-.247L8.06,15.9a.25.25,0,0,0-.288.247v3.182a.251.251,0,0,0,.169.237l3.227,1.117a.251.251,0,0,0,.227-.033.248.248,0,0,0,.105-.2Z', 'M24,14.951a.249.249,0,0,0-.288-.247l-1.546.238a.25.25,0,0,0-.212.247v1.985a.249.249,0,0,0,.332.236l1.546-.535A.251.251,0,0,0,24,16.639Z', 'M16.228,16.147a.25.25,0,0,0-.288-.247l-3.228.5a.25.25,0,0,0-.212.247v3.8a.248.248,0,0,0,.105.2.251.251,0,0,0,.227.033l3.227-1.117a.251.251,0,0,0,.169-.237Z', 'M11.5,2.144V1a.5.5,0,0,1,1,0V2.144L23.668,6.01A.249.249,0,0,0,24,5.774V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V5.774a.249.249,0,0,0,.332.236Z', 'M12.5,21.856V23a.5.5,0,0,1-1,0V21.856L.332,17.99A.249.249,0,0,0,0,18.226V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V18.226a.249.249,0,0,0-.332-.236Z', 'M17.228,8.084a.25.25,0,0,0,.212.247l3.226.5a.249.249,0,0,0,.288-.247V6.307a.249.249,0,0,0-.168-.236L17.559,4.954a.246.246,0,0,0-.226.032.25.25,0,0,0-.1.2Z', 'M7.772,7.853A.25.25,0,0,0,8.06,8.1l3.228-.5a.25.25,0,0,0,.212-.247v-3.8a.248.248,0,0,0-.105-.2.251.251,0,0,0-.227-.033L7.941,4.434a.251.251,0,0,0-.169.237Z', 'M6.772,15.916a.25.25,0,0,0-.212-.247l-3.226-.5a.249.249,0,0,0-.288.247v2.273a.249.249,0,0,0,.168.236l3.227,1.117a.246.246,0,0,0,.226-.032.25.25,0,0,0,.105-.2Z', 'M12.5,7.357a.25.25,0,0,0,.212.247l3.228.5a.25.25,0,0,0,.288-.247V4.671a.251.251,0,0,0-.169-.237L12.832,3.317a.251.251,0,0,0-.227.033.248.248,0,0,0-.105.2Z', 'M0,9.049A.249.249,0,0,0,.288,9.3l1.546-.238a.25.25,0,0,0,.212-.247V6.826a.249.249,0,0,0-.332-.236L.168,7.125A.251.251,0,0,0,0,7.361Z']],
  GridRuler: ['grid-ruler', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H16.5a3.741,3.741,0,0,0,2.414-1L23,18.914A3.745,3.745,0,0,0,24,16.5ZM18,16a2,2,0,0,0-2,2v3.75a.25.25,0,0,1-.25.25h-8a.25.25,0,0,1-.25-.25v-14a.25.25,0,0,1,.25-.25h14a.25.25,0,0,1,.25.25v8a.25.25,0,0,1-.25.25ZM22,5.75a.25.25,0,0,1-.25.25h-1.5A.25.25,0,0,1,20,5.75V4a.75.75,0,0,0-1.5,0V5.75a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25V5A.75.75,0,0,0,14,5v.75a.25.25,0,0,1-.25.25h-2.5A.25.25,0,0,1,11,5.75V4A.75.75,0,0,0,9.5,4V5.75A.25.25,0,0,1,9.25,6H7.75a.25.25,0,0,1-.25-.25V2.25A.25.25,0,0,1,7.75,2H21.5a.5.5,0,0,1,.5.5ZM5.75,2A.25.25,0,0,1,6,2.25v3.5A.25.25,0,0,1,5.75,6H2.25A.25.25,0,0,1,2,5.75V2.5A.5.5,0,0,1,2.5,2ZM2,7.75a.25.25,0,0,1,.25-.25h3.5A.25.25,0,0,1,6,7.75v1.5a.25.25,0,0,1-.25.25H4A.75.75,0,0,0,4,11H5.75a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25H5a.75.75,0,0,0,0,1.5h.75a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25H4A.75.75,0,0,0,4,20H5.75a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H2.5a.5.5,0,0,1-.5-.5ZM18.427,20.659A.25.25,0,0,1,18,20.482V18.25a.25.25,0,0,1,.25-.25h2.232a.25.25,0,0,1,.177.427Z']],
  GridRuler1: ['grid-ruler-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.645,13.92,21.876,7.6a.252.252,0,0,0-.177-.175.255.255,0,0,0-.241.065l-3.926,3.927a.25.25,0,0,0,0,.353l3.889,3.888a1.253,1.253,0,0,0,1.768,0A1.917,1.917,0,0,0,23.645,13.92Z', 'M16.509,2.542a.25.25,0,0,0-.109-.417L10.081.356A1.908,1.908,0,0,0,8.34.811a1.252,1.252,0,0,0,0,1.768l3.889,3.89a.249.249,0,0,0,.354,0Z', 'M21.245,6.291a.5.5,0,0,0,0-.707L18.417,2.756a.5.5,0,0,0-.707,0L.739,19.726a1.5,1.5,0,0,0,0,2.122l1.414,1.413a1.5,1.5,0,0,0,2.121,0h0l3.472-3.472a.249.249,0,0,0,0-.354L6.2,17.893a.5.5,0,0,1,.705-.709l1.554,1.545a.25.25,0,0,0,.353,0l1.56-1.561a.251.251,0,0,0,0-.354L8.816,15.272a.5.5,0,1,1,.705-.709l1.554,1.545a.25.25,0,0,0,.353,0l1.561-1.562a.25.25,0,0,0,.074-.177.256.256,0,0,0-.074-.177l-1.552-1.541a.5.5,0,1,1,.705-.709L13.7,13.486a.25.25,0,0,0,.353,0Z']],
  PerspectiveGrid: ['perspective-grid', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM6.708,22a.25.25,0,0,1-.2-.4A16.05,16.05,0,0,0,9.255,15.59a.251.251,0,0,1,.29-.191,6.664,6.664,0,0,1,2.094.757,8.662,8.662,0,0,0,3.284,1.079.25.25,0,0,1,.2.346,14.249,14.249,0,0,1-2.885,4.343.253.253,0,0,1-.18.076ZM2,11.112a.25.25,0,0,1,.08-.183L3.734,9.4A6.682,6.682,0,0,1,6.788,7.8a.25.25,0,0,1,.3.174A14.408,14.408,0,0,1,7.652,12c0,.369-.018.735-.047,1.1a.249.249,0,0,1-.223.229,8.693,8.693,0,0,0-5,2.257A.225.225,0,0,1,2,15.419ZM12.06,2a.253.253,0,0,1,.18.076,14.223,14.223,0,0,1,3.218,5.187.252.252,0,0,1-.041.239.248.248,0,0,1-.223.092,6.645,6.645,0,0,1-2.563-.826,8.692,8.692,0,0,0-4.1-1.137.247.247,0,0,1-.222-.15A16.026,16.026,0,0,0,6.508,2.4a.25.25,0,0,1,.2-.4Zm.571,12.42a8.664,8.664,0,0,0-2.823-1,.249.249,0,0,1-.206-.265c.029-.382.05-.766.05-1.154a16.318,16.318,0,0,0-.5-3.963.249.249,0,0,1,.283-.308,6.651,6.651,0,0,1,2.2.775,8.68,8.68,0,0,0,4.2,1.138.25.25,0,0,1,.244.212A14.131,14.131,0,0,1,16.261,12a14.329,14.329,0,0,1-.348,3.1.251.251,0,0,1-.255.2A6.7,6.7,0,0,1,12.631,14.42Zm5.439-4.8a.251.251,0,0,1,.182-.278A8.678,8.678,0,0,0,21.589,7.6.249.249,0,0,1,22,7.788V11.96a.251.251,0,0,1-.073.177l-1.2,1.2a6.649,6.649,0,0,1-2.344,1.516.249.249,0,0,1-.336-.273A16.187,16.187,0,0,0,18.261,12,16.092,16.092,0,0,0,18.07,9.617ZM22,4.308a.251.251,0,0,1-.073.177l-1.2,1.2a6.645,6.645,0,0,1-2.885,1.683.249.249,0,0,1-.308-.167,16.039,16.039,0,0,0-2.42-4.8.25.25,0,0,1,.2-.4H21.5a.5.5,0,0,1,.5.5ZM3.451,2a.253.253,0,0,1,.18.076,14.24,14.24,0,0,1,2.5,3.515.251.251,0,0,1-.156.353A8.688,8.688,0,0,0,2.377,7.932a.223.223,0,0,1-.242.041A.225.225,0,0,1,2,7.767V2.5A.5.5,0,0,1,2.5,2ZM2,18.765a.25.25,0,0,1,.08-.184l1.654-1.527a6.68,6.68,0,0,1,3.115-1.615.249.249,0,0,1,.295.309,14.158,14.158,0,0,1-3.513,6.176.254.254,0,0,1-.18.076H2.5a.5.5,0,0,1-.5-.5ZM15.317,22a.25.25,0,0,1-.2-.4,16.032,16.032,0,0,0,2.253-4.289.251.251,0,0,1,.191-.165,8.708,8.708,0,0,0,4.031-1.9.249.249,0,0,1,.266-.036A.251.251,0,0,1,22,15.44V21.5a.5.5,0,0,1-.5.5Z']],
  GridGuides: ['grid-guides', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,12.5a1,1,0,0,0,0-2H18.25a.25.25,0,0,1-.25-.25v-3A.25.25,0,0,1,18.25,7H23a1,1,0,0,0,0-2H18.25A.25.25,0,0,1,18,4.75V1a1,1,0,0,0-2,0V4.75a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V1a1,1,0,0,0-2,0V4.75a.25.25,0,0,1-.25.25h-3A.25.25,0,0,1,7,4.75V1A1,1,0,0,0,5,1V4.75A.25.25,0,0,1,4.75,5H1A1,1,0,0,0,1,7H4.75A.25.25,0,0,1,5,7.25v3a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H4.75a.25.25,0,0,1,.25.25v3a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H4.75a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0V18.25A.25.25,0,0,1,7.25,18h3a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0V18.25a.25.25,0,0,1,.25-.25h3a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0V18.25a.25.25,0,0,1,.25-.25H23a1,1,0,0,0,0-2H18.25a.25.25,0,0,1-.25-.25v-3a.25.25,0,0,1,.25-.25ZM15.75,7a.25.25,0,0,1,.25.25v3a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25v-3A.25.25,0,0,1,12.75,7ZM7,7.25A.25.25,0,0,1,7.25,7h3a.25.25,0,0,1,.25.25v3a.25.25,0,0,1-.25.25h-3A.25.25,0,0,1,7,10.25ZM7.25,16A.25.25,0,0,1,7,15.75v-3a.25.25,0,0,1,.25-.25h3a.25.25,0,0,1,.25.25v3a.25.25,0,0,1-.25.25ZM16,15.75a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25v-3a.25.25,0,0,1,.25-.25h3a.25.25,0,0,1,.25.25Z']],
  RulerTriangle: ['ruler-triangle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.388,22.2l-3.263-3.262a.249.249,0,0,0-.353,0L18.6,20.112a.5.5,0,0,1-.707-.707l1.177-1.176a.252.252,0,0,0,0-.354l-2.44-2.439a.249.249,0,0,0-.353,0L15.1,16.612a.5.5,0,0,1-.707-.707l1.177-1.176a.252.252,0,0,0,0-.354l-2.44-2.439a.249.249,0,0,0-.353,0L11.6,13.112a.5.5,0,0,1-.707-.707l1.177-1.176a.252.252,0,0,0,0-.354L9.633,8.444a.249.249,0,0,0-.353,0L8.111,9.612A.5.5,0,0,1,7.4,8.9L8.572,7.737a.25.25,0,0,0,0-.354L6.133,4.944a.249.249,0,0,0-.353,0L4.611,6.112A.5.5,0,0,1,3.9,5.405L5.072,4.237a.25.25,0,0,0,0-.354L1.8.612C1.068-.121.241.3.241,1.259v21a1.5,1.5,0,0,0,1.5,1.5h21C23.692,23.759,24.122,22.933,23.388,22.2ZM3.741,10.759c0-.55.319-.682.707-.293l9.086,9.086c.389.389.257.707-.293.707h-8.5a1,1,0,0,1-1-1Z']]
};
exports["default"] = _default;